
import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'cerrix-icon-button',
    imports: [MatButtonModule, MatTooltipModule, MatIconModule],
    templateUrl: './cerrix-icon-button.component.html',
    styleUrl: './cerrix-icon-button.component.scss'
})
export class CerrixIconButtonComponent implements OnDestroy {
  @Input() public disabled: boolean = false;
  @Input() public color: 'accent-text' | 'accent-link' = 'accent-text';
  @Input() public tooltipContent: string | undefined = undefined;
  @Input() public size: 'small' | 'default' = 'default';
   @Input() public dataUiid: string = "undefined"

  @HostBinding('class.disabled') public get hasClassDisabled(): boolean {
    return this.disabled;
  }

  private elementRef = inject(ElementRef);

  constructor() {
    this.elementRef.nativeElement.addEventListener(
      'click',
      this.haltDisabledEvents
    );
  }

  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener(
      'click',
      this.haltDisabledEvents
    );
  }

  haltDisabledEvents = (event: Event): void => {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  };
}
